import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './design/tokens.css';
import './design/app.css';
import './design/polish.css';
import './design/glass.css';
import { installWallpaper } from './design/wallpaper';
import { language, setLanguage } from './i18n/i18n';
import { App } from './ui/App';
import { applyTheme, storedTheme } from './ui/theme';
import { installKeyboardViewport } from './ui/keyboardViewport';
import { installErrorReporting } from './ui/errorReporting';
import { installThreadWindowClient, threadWindowRootId, ThreadWindowApp } from './ui/features/extras/threadWindow';

// First: an error anywhere after this reaches Satori Core (shared/API.md §45).
installErrorReporting();
applyTheme(storedTheme());
setLanguage(language());
installWallpaper();

// The offline shell (public/sw.js) — production builds only: in dev it would cache Vite's modules.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js').catch((e) => console.warn('[satori] sw', e)));
}

installKeyboardViewport();

// «Abrir el hilo en una ventana» (PARITY P317): a popup that borrows its opener's worker and draws
// only the thread — never the app (a second App would contend for the one-tab database lock).
const threadWindow = threadWindowRootId();
if (threadWindow) installThreadWindowClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>{threadWindow ? <ThreadWindowApp rootId={threadWindow} /> : <App />}</StrictMode>,
);
